<h1 class="fs-2 fw-bold">{{ 'label.register-for-test' | translate }}</h1>
<app-candidate-form></app-candidate-form>
